// extracted by mini-css-extract-plugin
export default {"cards-section":"Catalogue_cards-section__-k5WR","recipe-card-list":"Catalogue_recipe-card-list__jRg5X"};